export const SLIDESHOW_SELECTION_EVENT = 'cms:slideshow-selection';
export const SLIDESHOW_CANVAS_SELECTION_EVENT = 'cms:slideshow-canvas-selection';

export type SlideshowSelectionDetail = { componentId: string; index: number };
export type SlideshowCanvasSelectionDetail = SlideshowSelectionDetail;

export function announceSlideshowSelection(componentId: string, index: number): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<SlideshowSelectionDetail>(SLIDESHOW_SELECTION_EVENT, { detail: { componentId, index } })
  );
}

export function announceSlideshowCanvasSelection(componentId: string, index: number): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<SlideshowCanvasSelectionDetail>(SLIDESHOW_CANVAS_SELECTION_EVENT, {
      detail: { componentId, index },
    })
  );
}
